<template>
  <div class="pdp-scene">
    <div class="pdp-scene__header">
      <i class="bi bi-image-alt" /> <b>Lifestyle</b> · place product on a background
    </div>

    <div
      class="pdp-scene__tabs"
      role="tablist"
    >
      <button
        v-for="t in tabs"
        :key="t.key"
        type="button"
        class="pdp-scene__tab"
        :class="{ 'is-active': activeTab === t.key }"
        :disabled="disabled || t.disabled"
        @click="activeTab = t.key"
      >
        <i :class="t.icon" /> {{ t.label }}
      </button>
    </div>

    <div class="pdp-scene__body">
      <div v-if="activeTab === 'generate'">
        <p class="pdp-scene__hint">
          I'll generate a lifestyle background from the product context.
        </p>
        <input
          v-model="generatePrompt"
          type="text"
          class="pdp-scene__input"
          :placeholder="defaultScenePrompt || 'e.g. on a kitchen counter at golden hour'"
          :disabled="disabled"
        >
      </div>
      <div v-else-if="activeTab === 'paste'">
        <input
          v-model="pasteUrl"
          type="text"
          class="pdp-scene__input"
          placeholder="Paste an image URL"
          :disabled="disabled"
        >
      </div>
      <div v-else-if="activeTab === 'upload'">
        <p class="pdp-scene__hint">
          Direct upload coming soon — use the Files tab to pick from your library.
        </p>
      </div>
      <div v-else-if="activeTab === 'files'">
        <p class="pdp-scene__hint">
          Click Composite to open the file browser.
        </p>
      </div>
    </div>

    <div class="pdp-scene__actions">
      <button
        type="button"
        class="btn btn-sm btn-primary"
        :disabled="disabled || !canComposite"
        @click="onComposite"
      >
        <i class="bi bi-stars" /> Composite
      </button>
      <button
        type="button"
        class="pdp-scene__skip"
        :disabled="disabled"
        @click="$emit('skip')"
      >
        Skip this image
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIChatWidgetPdpScenePicker',
  props: {
    rowIndex: { type: Number, required: true },
    defaultScenePrompt: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      activeTab: 'generate',
      generatePrompt: '',
      pasteUrl: '',
      tabs: [
        { key: 'generate', label: 'Generate', icon: 'bi bi-stars' },
        { key: 'upload', label: 'Upload', icon: 'bi bi-upload', disabled: true },
        { key: 'paste', label: 'Paste', icon: 'bi bi-clipboard' },
        { key: 'files', label: 'Files', icon: 'bi bi-folder' },
      ],
    };
  },
  computed: {
    canComposite() {
      if (this.activeTab === 'generate') return true;
      if (this.activeTab === 'paste') return !!this.pasteUrl.trim();
      if (this.activeTab === 'files') return true;
      return false;
    },
  },
  methods: {
    onComposite() {
      this.$emit('composite', {
        rowIndex: this.rowIndex,
        sceneSource: this.activeTab,
        userInstructions: this.activeTab === 'generate' ? (this.generatePrompt || this.defaultScenePrompt || '') : '',
        pasteUrl: this.activeTab === 'paste' ? this.pasteUrl.trim() : '',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pdp-scene {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  margin-top: 8px;
  font-size: 13px;
}
.pdp-scene__header { font-weight: 600; color: #1a1a2e; }
.pdp-scene__tabs { display: flex; gap: 4px; }
.pdp-scene__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}
.pdp-scene__tab.is-active { background: #eaf7f2; border-color: #379C75; color: #2d6a55; }
.pdp-scene__hint { color: #64748b; font-size: 12px; margin: 0; }
.pdp-scene__input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 13px;
}
.pdp-scene__actions { display: flex; align-items: center; gap: 12px; margin-top: 4px; }
.pdp-scene__skip {
  background: transparent;
  border: none;
  padding: 0;
  color: #94a3b8;
  font-size: 12px;
  cursor: pointer;
}
.pdp-scene__skip:hover { color: #475569; }
.pdp-scene__skip:disabled { cursor: not-allowed; opacity: 0.5; }
</style>
